<template>
  <div class="main-container">
    <!-- Author: Bhushan
      Date: 10/02/2021
      Description: Income Tax Proof components-->
    <!--  <breadcrumb :list="breadcrumbList" />  -->

    <div class="margintop-16" />
    <tl-header type="h1" class="employee-fullname"
      >Investment Proofs:
      {{ ` ${employeeObj.first_name} ${employeeObj.last_name ? employeeObj.last_name:''} ` }}</tl-header
    >
    <div class="lineheight"></div>
    <!-- Section 1 -->
    <div class="container-fluid" id="example">
      <div class="row">
        <div class="col-2 first">
          <div>
            <div class="img-user">
              <img src="@/assets/user.svg" class="oval" />
            </div>

            <div class="month">
              <div class="employee-fullname">
                {{ ` ${employeeObj.first_name} ${employeeObj.last_name ? employeeObj.last_name:''} ` }}
              </div>
              <div class="employee-code">{{ `${employeeObj.code}` }}</div>
              <div class="date"></div>
            </div>
          </div>
        </div>
        <div class="col-10-new last">
          <div class="row">
            <div class="col-6 left-box-6">
              <div class="row">
                <div class="col-6">
                  <div class="total-taxable-income">Planned Investment:</div>
                </div>
                <div class="col-6 amount-right">
                  <strong>₹ {{ `${totalPlannedInvestment}` }}</strong>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <div class="total-taxable-income">Actual Investment:</div>
                </div>
                <div class="col-6 amount-right">
                  <strong> ₹ 0 </strong>
                </div>
              </div>
            </div>
            <div class="col-6 right-box-6">
              <div class="row">
                <div class="col-6">
                  <div class="total-taxable-income">Salary and Perks:</div>
                </div>
                <div class="col-6 amount-right">
                  <strong>₹ {{ annualIncome }}</strong>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <div class="total-taxable-income">Total Taxable Income:</div>
                </div>
                <div class="col-6 amount-right">
                  <strong> ₹ {{ totalIncome }} </strong>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <div class="total-taxable-income">Annual Tax:</div>
                </div>
                <div class="col-6 amount-right">
                  <strong> ₹ {{ totalTax }} </strong>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div
                class="view-proof-title"
                @click="showPopupdependentsPopup = !showPopupdependentsPopup"
              >
                <span class="view-proof-title-pointer">View Dependents</span>
              </div>
            </div>
            <div class="col-4 side-hr-lr">
              <div class="view-proof-title">
                <span class="view-proof-title-pointer">View TDS Breakup</span>
              </div>
            </div>
            <div class="col-4">
              <div class="view-proof-title">
                <span class="view-proof-title-pointer">View IT Statement</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 1 -->

    <!-- Tabs Section -->
    <template >
    <div class="margintop-32" >
      <tl-tabs :tabs="tabs">
        <tl-tab>
          <pending v-if="isMounted==true" :dataAll="dataAll"></pending>
        </tl-tab>
        <tl-tab>
          <approved v-if="isMounted==true" :dataAll2="dataAll2"></approved>
        </tl-tab>
        <tl-tab>
          <rejected v-if="isMounted==true" :dataAll3="dataAll3"></rejected>
        </tl-tab>
        <tl-tab>
          <self-declaration-form v-if="isMounted==true" :urlArray="urlArray"> </self-declaration-form>
        </tl-tab>
      </tl-tabs>
    </div>
    </template>
    <!-- Tabs End Here -->
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="backpreviouspage" />
          <btn text="Save" type="primary" @click="submitProofs" />
        </btn-grp>
      </template>
    </bottom-action-container>
    <!-- Popup 1 -->
    <pop-up-window
      v-if="showPopupdependentsPopup"
      @back="showPopupdependentsPopup = !showPopupdependentsPopup"
      header="Dependents"
    >
      <template v-slot:content>
        <dependents-popup
          @back="showPopupdependentsPopup = !showPopupdependentsPopup"
          @openNewDependents="openNewDependents"
        >
        </dependents-popup>
      </template>
    </pop-up-window>
    <!-- End -->
    <!-- Popup 2 -->
    <pop-up-window
      v-if="showPopupaddDependentsPopup"
      @back="showPopupaddDependentsPopup = !showPopupaddDependentsPopup"
      header="Dependents"
    >
      <template v-slot:content>
        <add-dependents-popup
          @back="showPopupaddDependentsPopup = !showPopupaddDependentsPopup"
          @saveDependent="saveDependent"
        >
        </add-dependents-popup>
      </template>
    </pop-up-window>
    <!-- End -->

  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import dependentsPopup from "./dependentsPopup.vue";
import addDependentsPopup from "./addDependentsPopup.vue";
import { eventBus } from "@/main";
import {
  get_axios_file_instance,
  api_variables,
  errorHandler,
} from "@/apis/variables.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
import pending from "./pending.vue";
import approved from "./approved.vue";
import rejected from "./rejected.vue";
import selfDeclarationForm from "./selfDeclarationForm.vue";


export default {
  name: "incometaxproofplan",
  components: {
    dependentsPopup,
    addDependentsPopup,
    pending,
    approved,
    rejected,
    selfDeclarationForm,
  },
  data() {
    return {
      showDocModal: false,
      isMounted:false,
      employeeObj: null,
      showConfirmationMsg: false,
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      dataAll:null,
      dataAll2:null,
      dataAll3:null,
      title: null,
        data2: {
        exemption10: {
          HRA: [
            {
              address: "",
              pincode: "",
              State: "",
              cityType: "metro",
              rentList: [
                {
                  rentFrom: "",
                  rentTo: "",
                  amount: 0,
                  agreementDoc: "",
                  fileName: "",
                },
              ],
              ownerDetails: {
                name: "",
                pan_number: "",
                pincode: "",
                address: "",
                state: "",
                pancardUrl: "",
                fileName: "",
                isCoOwner: false,
                cownerDetails: {
                  name: "",
                  pan_number: "",
                  pincode: "",
                  address: "",
                  state: "",
                  pancardUrl: "",
                  fileName: "",
                },
              },
            },
          ],
          others: [],
        },
        exemption17: [],
        deductionsUnderChapterVIA: [],
        section24: [],
        previousEmploymentDetails: {},
        otherIncome: [],
        deductionsUnderSection16:{
        Section16:null
      },
        le_id: "",
        employee_id: "",
        financial_year: "",
        plan_id: "",
        regime_type: "",
      },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: [],
      },
      it_plan_id: "",
      employeeId: "",
      instance: {
        le_id: "",
        employee_id: "",
        financial_year: "",
        it_plan_id: "",
      },
    
      section10Update: [],

      salaryPerk: [],
      tds_breakup_and_taxable_income: [],
      itSheet: [],
      first_name: "",
      last_name: "",
      ctc: "",
      code: "",
      totalIncomeTax: "",
      annualIncome: 0,
      incomeTax: 0,
      totalIncome: 0,
      totalTax: 0,
      showPopupdependentsPopup: false,
      showPopupaddDependentsPopup: false,
      showPopupaddNewInvestmentPopup: false,
      showPopupviewDownloadFormsPopup: false,
      showPopupfullviewDownloadFormsPopup: false,
      showPopupuploadAttachment: false,
      showPopupfullAttachmentShow: false,
      showPopupsection10Popup: false,
      salaryTableColumns: [],
      deductionsList: [],
      perksList: [],
      salaryList: [],
      data80CList: [],
      chapterOtherDataList: [],
      showPopupsection17Popup: false,
      showPopupChapterVIAPopup: false,
      section10record: [],
      section17record: [],
      section6arecord: [],
      section10List: [],
      section17List: [],
      iTaxProofPlan: true,
      iTaxProofFormPlan: false,
      showDeleteConfirmation: false,
      section10sum: 0,
      section17sum: 0,
      chapter6asum: 0,
      section24sum: 0,
      otherincomesum: 0,
      totalPlannedInvestment: 0,
      showApproveConfirmation: false,
      urlArray:[],
      section24: {
        let_out_property: [
          {
            letOut: [],
            total_planned: 0,
            total_actual: 0,
            total_approved:0,
            status:null,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0,
          },
        ],
        self_occupied: {
          selfOccupied: [],
          total_planned: 0,
          total_actual: 0,
          total_approved:0,
          status:null,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0,
        },
      },
      previousEmploymentDetails: {
        salary_income: { amount: 0, location: [],approved:0,status:null },
        pt: { amount: 0, location: [],approved:0,status:null },
        vpf: { amount: 0, location: [],approved:0,status:null },
        pf: { amount: 0, location: [],approved:0,status:null },
        nps: { amount: 0, location: [],approved:0,status:null },
        tds: { amount: 0, location: [],approved:0,status:null },
      },
      otherIncomeList: [
        // {
        //   name: "Interest From saving Accounts",
        //   value: 123456,
        //   proof: [],
        //   actual: 0,
        //   planned: 0,
        //   approved:0,
        //   file_location: "",
        //   status: "",
        //   type: "",
        // },
        // {
        //   name: "Interest From Fixed Deposits",
        //   value: 123456,
        //   proof: [],
        //   actual: 0,
        //   planned: 0,
        //   approved:0,
        //   file_location: "",
        //   status: "",
        //   type: "",
        // },
        // {
        //   name: "Any other Income",
        //   value: 123456,
        //   proof: [],
        //   actual: 0,
        //   planned: 0,
        //   approved:0,
        //   file_location: "",
        //   status: "",
        //   type: "",
        // },
      ],
      tabs: [
        {
          header: "All",
        },
        {
          header: "Approval",
        },
        {
          header: "Rejected",
        },
        {
          header: "Self Declaration Form",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData",
    }),
    ...mapState({
      globalData: (state) => state.globalapi.globalData.data,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
  },

  mounted() {
   this.fetechAllNewInvestment();
    
  },
  activated() {
     this.fetechAllNewInvestment();
    // this.isMounted = true;
  },
  created() {
    eventBus.$on('approveInvestment', this.approveInvestmentFunction);
    eventBus.$on('approveInvestment2', this.approveInvestmentFunction2);
    eventBus.$on('approveInvestment3', this.approveInvestmentFunction3);
    eventBus.$on('saveRejectProof', this.saveRejectProofFunction);
    eventBus.$on('saveRejectProof2', this.saveRejectProofFunction2);
    eventBus.$on('saveRejectProof3', this.rejectInvestmentFunction3);
    eventBus.$on('saveInvestmentProof', this.PartialApproveInvestmentFunction);
    eventBus.$on('saveInvestmentProof2', this.PartialApproveInvestmentFunction2);
    eventBus.$on('saveInvestmentProof3', this.PartialApproveInvestmentFunction3);
    eventBus.$on('addRejectProof', this.saveRejectProofFunction);
    eventBus.$on('addRejectProof2', this.saveRejectProofFunction2);
    eventBus.$on('addRejectProof3', this.rejectInvestmentFunction3);
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_it_data: "dashboard/payroll/incometax/setItData",
      act_save_it_plan: "dashboard/payroll/incometax/createItData",
      act_get_active_it_plan: "dashboard/payroll/incometax/getActiveList",
    }),

    async fetechAllNewInvestment() {
      
      let empId = this.$route.query.id;
      this.instance.employee_id = empId;
      let payload ={
          empId:empId,
          empLeId:this.le_id
        }
      let employeeDetail = await this.act_fetchEmpById(payload);
      this.employeeObj = employeeDetail.data.payload.data;
      this.empCtc = this.employeeObj.EmployeeSalarySetting[0].ctc;
      this.instance.employee_id = empId;
      this.instance.financial_year = this.payrollYear;
      this.instance.le_id = this.le_id;
      
      let res = await this.act_get_active_it_plan(empId);
      
      this.urlArray=res.data.payload.future_declaration_files;


      this.instance.it_plan_id = res.data.payload.id;
      this.fetchItData();
    },

      async fetchItData() {
      
      let res = await this.act_set_it_data(this.instance);

      if (res.data.status) {
       
        this.salaryList = [];
        this.deductionsList = [];
        this.perksList = [];
        let obj = res.data.payload;
        this.dataAll=obj;
        this.dataAll2=this.dataAll;
        this.dataAll3=this.dataAll
        this.totalTax = obj.itSheet[0].totalTax;
        this.totalIncome = obj.itSheet[0].taxableIncome;
        this.incomeTax = obj.itSheet[0].incomeTax;
        this.annualIncome = obj.itSheet[0].totalEarning;
       this.data80CList = [];
          this.section10List =[];
          this.section17List=[];
      this.data2.exemption10=obj.Exemption10;
      this.data2.exemption17= obj.Exemption17;
      this.data2.deductionsUnderChapterVIA=obj.deductionsUnderChapterVIA;
      this.data2.section24=obj.section24;
      this.data2.previousEmploymentDetails=obj.previousEmploymentDetails;
      this.data2.otherIncome=obj.otherIncome;
      this.data2.deductionsUnderSection16.Section16=obj.deductionsUnderSection16
      this.data2.le_id=obj.le_id;
      this.data2.employee_id=this.instance.employee_id;
      this.data2.financial_year=this.instance.financial_year;
            this.data2.plan_id=this.instance.it_plan_id;
          /* Section 10 data table push*/
          

          obj.Exemption10.others.forEach(element => {
              this.regime_type=element.regime_type;
              this.section10List.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
                
              });
             
          });
          
           /* Section 17 data table push*/
          obj.Exemption17.Section17.forEach(element => {
            
              this.section17List.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
            
          });
          /* ChapterVIA data table push*/
          obj.deductionsUnderChapterVIA.forEach(element => {
            
              this.data80CList.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
          });
          /* let out property data table push*/
          if (Object.keys(obj.section24).length && obj.section24.let_out_property !=null) {
            if (obj.section24.let_out_property.length) {
              this.section24.let_out_property = obj.section24.let_out_property;
            }
            this.section24.self_occupied = obj.section24.self_occupied;
            this.section24sum=this.section24.let_out_property.total_planned;
            
          }
         /* Other Income data table push*/
         if (obj.otherIncome.length) {
            this.otherIncomeList = obj.otherIncome;
             this.otherIncomeList.forEach(element => {
             this.otherincomesum += element.planned
            
          });
          }
           
            /* previous employment Details data table push*/
           if (Object.keys(obj.previousEmploymentDetails).length) {
            this.previousEmploymentDetails = obj.previousEmploymentDetails;
            
          }
           
          this.section10List.forEach(element =>{
            this.section10sum += element.planned
          })
          this.section17List.forEach(element =>{
            this.section17sum += element.planned
          })
          this.data80CList.forEach(element =>{
            this.chapter6asum += element.planned
          })
         
          this.totalPlannedInvestment=0;
      this.totalPlannedInvestment=this.section10sum+this.section17sum+this.chapter6asum+this.otherincomesum;
   
         this.data2.exemption10.HRA = obj.Exemption10.HRA;
         this.isMounted = true;
      }
       
    },

    // Emit function call here
    approveInvestmentFunction(approvalData) {
      let data= approvalData;
       data.audited=true;
       data.approved=approvalData.actual;
       data.status='approved';
      
      if(approvalData.InvestmentComponentType.mapToItSectionId=='Section10'){
      for(let i=0;i<this.section10List.length;i++){
          if(this.section10List[i].id==approvalData.id)
          {
               this.section10List[i].audited=data.audited;
               this.section10List[i].approved=data.actual;
               this.section10List[i].status=data.status; 
          }
        }
        
      }
      if(approvalData.InvestmentComponentType.mapToItSectionId=='Section17'){
      for(let i=0;i<this.section17List.length;i++){
          if(this.section17List[i].id==approvalData.id)
          {
               this.section17List[i].audited=data.audited;
               this.section17List[i].approved=data.actual;
               this.section17List[i].status=data.status; 
          }
        }
        
      }
      if(approvalData.InvestmentComponentType.mapToItSectionId=='SectionVIA'){
      for(let i=0;i<this.data80CList.length;i++){
          if(this.data80CList[i].id==approvalData.id)
          {
               this.data80CList[i].audited=data.audited;
               this.data80CList[i].approved=data.actual;
               this.data80CList[i].status=data.status; 
          }
        }
        
      }
    },
      approveInvestmentFunction2(approvalData) {
      let data= approvalData;
       data.audited=true;
       data.approved=approvalData.actual;
       data.status='approved';
      
      for(let i=0;i<this.otherIncomeList.length;i++){
          if(this.otherIncomeList[i].name==approvalData.name)
          {
               this.otherIncomeList[i].audited=data.audited;
               this.otherIncomeList[i].approved=data.actual;
               this.otherIncomeList[i].status=data.status; 
          }
        }
        
    
    },
    approveInvestmentFunction3(data,info){
      if(info=='salary_income'){
        this.previousEmploymentDetails.salary_income=data;
      }else if(info=='PT'){
        this.previousEmploymentDetails.pt=data;
      }else if(info=='VPF'){
        this.previousEmploymentDetails.vpf=data;
      }else if(info=='PF'){
        this.previousEmploymentDetails.pf=data;
      }else if(info=='NPS'){
        this.previousEmploymentDetails.nps=data;
      }else if(info=='TDS'){
        this.previousEmploymentDetails.tds=data;
      }else{
        //console.log("something is wrong !!!!");
      }
        
      },
      rejectInvestmentFunction3(data,info){
      if(info=='salary_income'){
        this.previousEmploymentDetails.salary_income=data;
      }else if(info=='PT'){
        this.previousEmploymentDetails.pt=data;
      }else if(info=='VPF'){
        this.previousEmploymentDetails.vpf=data;
      }else if(info=='PF'){
        this.previousEmploymentDetails.pf=data;
      }else if(info=='NPS'){
        this.previousEmploymentDetails.nps=data;
      }else if(info=='TDS'){
        this.previousEmploymentDetails.tds=data;
      }else{
        //console.log("something is wrong !!!!");
      }
        
      },
      PartialApproveInvestmentFunction3(data,info){
      if(info=='salary_income'){
        this.previousEmploymentDetails.salary_income=data;
      }else if(info=='PT'){
        this.previousEmploymentDetails.pt=data;
      }else if(info=='VPF'){
        this.previousEmploymentDetails.vpf=data;
      }else if(info=='PF'){
        this.previousEmploymentDetails.pf=data;
      }else if(info=='NPS'){
        this.previousEmploymentDetails.nps=data;
      }else if(info=='TDS'){
        this.previousEmploymentDetails.tds=data;
      }else{
        //console.log("something is wrong !!!!");
      }
        
      },

     PartialApproveInvestmentFunction2(partialApproveData){
             let flag=false;
             let flag2=false;
             this.otherIncomeList.forEach( (item)=> {
               if (item.name == partialApproveData.name) {
                    
                    flag=true;
                    if(item.approved !=partialApproveData.approved)
                    {
                      flag2=true;
                    }
                } 
           });
               if(flag != true)
                  this.otherIncomeList.push(partialApproveData);
          if(flag2 == true){
            for(let i=0;i<this.otherIncomeList.length;i++){
              if(this.otherIncomeList[i].id==partialApproveData.id)
              {
                 this.otherIncomeList[i].approved=partialApproveData.approved;
                this.otherIncomeList[i].audit_remarks=partialApproveData.audit_remarks; 
              }
            }
          }
        
    },

    PartialApproveInvestmentFunction(partialApproveData){
       if(partialApproveData.InvestmentComponentType.mapToItSectionId=='Section10'){
             let flag=false;
             let flag2=false;
             this.section10List.forEach( (item)=> {
               if (item.id === partialApproveData.id) {
                    
                    flag=true;
                    if(item.approved !=partialApproveData.approved)
                    {
                      flag2=true;
                    }
                } 
           });
               if(flag != true)
                  this.section10List.push(partialApproveData);
          if(flag2 == true){
            for(let i=0;i<this.section10List.length;i++){
              if(this.section10List[i].id==partialApproveData.id)
              {
                 this.section10List[i].approved=partialApproveData.approved;
                this.section10List[i].audit_remarks=partialApproveData.audit_remarks; 
              }
            }
          }
        
        }
        if(partialApproveData.InvestmentComponentType.mapToItSectionId=='Section17'){
           let flag=false;
             let flag2=false;
             this.section17List.forEach( (item)=> {
               if (item.id === partialApproveData.id) {
                    
                    flag=true;
                    if(item.approved !=partialApproveData.approved)
                    {
                      flag2=true;
                    }
                } 
           });
               if(flag != true)
                  this.section17List.push(partialApproveData);
          if(flag2 == true){
            for(let i=0;i<this.section17List.length;i++){
              if(this.section17List[i].id==partialApproveData.id)
              {
                 this.section17List[i].approved=partialApproveData.approved;
                this.section17List[i].audit_remarks=partialApproveData.audit_remarks; 
              }
            }
          }
        }//data80CList
        if(partialApproveData.InvestmentComponentType.mapToItSectionId=='SectionVIA'){
          let flag=false;
             let flag2=false;
             this.data80CList.forEach( (item)=> {
               if (item.id === partialApproveData.id) {
                    
                    flag=true;
                    if(item.approved !=partialApproveData.approved)
                    {
                      flag2=true;
                    }
                } 
           });
               if(flag != true)
                  this.data80CList.push(partialApproveData);
          if(flag2 == true){
            for(let i=0;i<this.data80CList.length;i++){
              if(this.data80CList[i].id==partialApproveData.id)
              {
                 this.data80CList[i].approved=partialApproveData.approved;
                this.data80CList[i].audit_remarks=partialApproveData.audit_remarks; 
              }
            }
          }
        
        }
    },

    saveRejectProofFunction(rejectData) {
      
      let data= rejectData;
       
      if(rejectData.InvestmentComponentType.mapToItSectionId=='Section10'){
      for(let i=0;i<this.section10List.length;i++){
          if(this.section10List[i].id==rejectData.id)
          {
               this.section10List[i].audited=true;
               this.section10List[i].approved=0;
               this.section10List[i].status='rejected';
               this.section10List[i].audit_remarks=data.audit_remarks; 
          }
        }
        
      }
      if(rejectData.InvestmentComponentType.mapToItSectionId=='Section17'){
      for(let i=0;i<this.section17List.length;i++){
          if(this.section17List[i].id==rejectData.id)
          {
               this.section17List[i].audited=true;
               this.section17List[i].approved=0;
               this.section17List[i].status='rejected';
               this.section17List[i].audit_remarks=data.audit_remarks; 
          }
        }
        
      }
      if(rejectData.InvestmentComponentType.mapToItSectionId=='SectionVIA'){
      for(let i=0;i<this.data80CList.length;i++){
          if(this.data80CList[i].id==rejectData.id)
          {
               this.data80CList[i].audited=true;
               this.data80CList[i].approved=0;
               this.data80CList[i].status='rejected';
               this.data80CList[i].audit_remarks=data.audit_remarks; 
          }
        }
        
      }
    

    },
     saveRejectProofFunction2(rejectData) {
      
      let data= rejectData;
       
      for(let i=0;i<this.otherIncomeList.length;i++){
          if(this.otherIncomeList[i].name==rejectData.name)
          {
               this.otherIncomeList[i].audited=true;
               this.otherIncomeList[i].approved=0;
               this.otherIncomeList[i].status='rejected';
               this.otherIncomeList[i].audit_remarks=data.audit_remarks; 
          }
        }
        
      
    

    },
    
    openNewDependents() {
      this.showPopupdependentsPopup = false;
      this.showPopupaddDependentsPopup = true;
    },

    saveDependent() {
      this.showPopupdependentsPopup = true;
      this.showPopupaddDependentsPopup = false;
    },

    async submitProofs() {
        this.data2.exemption10.others=this.section10List;
      this.data2.exemption17.Section17= this.section17List;
      this.data2.deductionsUnderChapterVIA=this.data80CList;
      this.data2.section24=this.section24;
      this.data2.previousEmploymentDetails=this.previousEmploymentDetails;
      this.data2.otherIncome=this.otherIncomeList;
      this.data2.regime_type=this.regime_type;
      
        let res = await this.act_save_it_plan(this.data2);
      if(res.status){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofapproval`,
      });
      }
    },

    backpreviouspage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofapproval`,
      });
      //window.location.reload();
      this.$router.go();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

// modal css previous employer
a.arrow.arrow-prev {
  font-size: 25px;
  font-weight: 600;
  margin: 0 10px;
}
a.arrow.arrow-next {
  font-size: 25px;
  font-weight: 600;
  margin: 0 10px;
}
img.docImage {
  width: 370px;
}
.custom-modal .modal-content .modal-footer {
  width: 100%;
}
span.delete-download {
  margin: 0 20px;
}
.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
  border: 1px solid #37c6c0;
  border-radius: 4px;
  padding: 14px;
}

// End here

.col-10-new {
  -ms-flex: 0 0 83.33334%;
  -webkit-box-flex: 0;
  flex: 0 0 83.33334%;
  max-width: 83.33334%;
}

.left-box-6 {
  padding: 25px;
  border-right-width: 0;
  border: 1px solid #c9c9c9;
  border-left-width: 0;
  border-top-width: 0;
}

.right-box-6 {
  padding: 25px;
  border: 1px solid #c9c9c9;
  border-right-width: 0;
  border-top-width: 0;
  border-left-width: 0;
}

.amount-right {
  text-align: right;
}

.side-hr-lr {
  border: 1px solid #c9c9c9;
  border-top-width: 0;
  border-bottom-width: 0;
  height: 55px;
}

.view-proof-title {
  text-align: center;
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.view-proof-title-pointer {
  cursor: pointer;
}

.add-new-investment {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.add-new-investment-pointer {
  cursor: pointer;
}

.img-icon {
  transform: translate(-1px, 5px);
}

.atch-img {
  margin-right: 10px;
  transform: rotate(45deg);
}

.attachment-text {
  transform: translate(0px, 2px);
  position: absolute;
  font-size: 12px;
}

.othersection {
  padding: 15px 0px;
  background-color: #f2f2f2;
}

.img-icon-success {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.success-title-proof {
  font-size: 14px;
  font-weight: 600;
  position: absolute;
  margin-top: 5px;
}

.edit-investment-plan {
  position: relative;
  margin-top: 5px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #5d409f;
}

.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center {
  margin: 500px;
}
.resize {
  margin-left: 100px;
}
.bold-text {
  width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new {
  width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 41px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight {
  height: 1px;
}

.img-user {
  margin: auto 0;
  text-align: center;
}

.month {
  margin-top: 8px;
  text-align: center;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
  position: absolute;
  cursor: pointer;
  color: #5d409f;
  right: 10px;
  top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

// #example .col-4 {
//   border: 1px solid #c9c9c9;
// }

// #example .col-4:not(:last-child) {
//   border-right-width: 0;
// }

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
  height: 210px;
  padding: 32px;
  border-radius: 10px 0px 0px 10px;
  border: solid 1px #dddddd;
}

.middle {
  //max-width:37%;
  height: 210px;
  padding: 32px;
  // border-radius: 10px 0px 0px 10px;
  // border: solid 1px #dddddd;
}

.last {
  // max-width: 37%;
  // flex: 0 0 37%;
  height: 210px;
  //padding: 32px;
  border-radius: 0px 10px 10px 0px;
  border: solid 1px #dddddd;
  border-left-width: 0;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}
.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}

.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background-color: rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px);
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 30%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: 20px;
    line-height: 25px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete {
    display: flex;
    align-items: center;
    *:nth-child(n) {
      margin-right: 20px;
    }
  }
  .warning {
    margin-bottom: 16px;
    text-align: center;
    height: 24px;
    width: 24px;
  }
  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: #34c0be solid 2px;
    color: #34c0be;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}
.success-img {
  position: relative;
  height: 24px;
  width: 24px;
  &.animated {
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: pulse;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showc {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showt {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }
  100% {
    padding-left: 0px;
    opacity: 1;
  }
}
@-webkit-keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }
  100% {
    padding-left: 0px;
    opacity: 1;
  }
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }
}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }
  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }
  10% {
    transform: scale3d(1, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@-webkit-keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }
  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }
  10% {
    transform: scale3d(1, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@-webkit-keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}
</style>
